<template>
  <div>
    <DashHeader />

    <div class="content-dash">
      <router-view />
    </div>

    <DashFooter />
  </div>
</template>

<script>
  // Importation du composant Header
  import DashHeader from "@/components/Header.vue";
  import DashFooter from "@/components/Footer.vue";

  export default {
    name: "App",
    components: {
      DashHeader, // Inclure le Header dans le composant App
      DashFooter, // Inclure le Footer dans le composant App
    },
  };
</script>
